import React from 'react';
import {Row, Column} from '../../global/grid/grid';

import { Title, ProcessCard } from './styled-components';

const ProcessCards = ({data}) => {
  return (
    <div>
        <Row margins={true}>
            <Column cw={12} style={{textAlign: 'center'}}>
                <Title>{data.title}</Title>
            </Column>
            <Column cw={4} style={{display: 'flex', textAlign: 'center', justifyContent: 'center'}}>
                <ProcessCard>
                    <div className="eyebrow">{data.card1.eyebrow}</div>
                    <div className="emphasis">{data.card1.emphasis}</div>
                    <div className="copy">{data.card1.copy}</div>
                </ProcessCard>
            </Column>
            <Column cw={4} style={{display: 'flex', textAlign: 'center', justifyContent: 'center'}}>
                <ProcessCard>
                    <div className="eyebrow">{data.card2.eyebrow}</div>
                    <div className="emphasis">{data.card2.emphasis}</div>
                    <div className="copy">{data.card2.copy}</div>
                </ProcessCard>
            </Column>
            <Column cw={4} style={{display: 'flex', textAlign: 'center', justifyContent: 'center'}}>
                <ProcessCard>
                    <div className="eyebrow">{data.card3.eyebrow}</div>
                    <div className="emphasis">{data.card3.emphasis}</div>
                    <div className="copy">{data.card3.copy}</div>
                </ProcessCard>
            </Column>
        </Row>
    </div>
  )
}

export default ProcessCards;



// WEBPACK FOOTER //
// ./src/components/modules/ProcessCards/ProcessCards.js